"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const activeStyling = `
  background-color: ${_styles.colors.pillActiveBackground};
  border-color: ${_styles.colors.accent};
  color: ${_styles.colors.accent};
  z-index: 2;
`;

const StyledButton = _styledComponents2.default.button.withConfig({
  displayName: "Pill__StyledButton",
  componentId: "doc0o6-0"
})(["background:none;border:1px solid ", ";color:", ";cursor:pointer;font-size:14px;line-height:20px;text-align:center;height:40px;padding-left:", "px;padding-right:", "px;margin-right:-1px;transition:border-radius 0.1s ease-in-out;outline:none;z-index:0;&:first-child{border-radius:4px 0 0 4px;}&:last-child{border-radius:0 4px 4px 0;}&:hover{border-color:", ";z-index:1;}", ""], _styles.colors.border, _styles.colors.black, (0, _styles.calcPadding)(4), (0, _styles.calcPadding)(4), _styles.colors.accentFocusInput, props => props.active ? activeStyling : null);

const Pill = (_ref) => {
  let { children } = _ref,
      props = _objectWithoutProperties(_ref, ["children"]);

  return _react2.default.createElement(
    StyledButton,
    props,
    children
  );
};

Pill.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  active: _propTypes2.default.bool
};

exports.default = Pill;